import _ from 'lodash';
import { requestorHelperService } from '@/requestors/requestor-helper-service.js';

function getSlideRequest (data, title, subtitle, settings) {
    let chartSlide = { SlideType: 'final-scores', ChartRequests: [] };
    let slideTitle = 'Conversability Scorecard';
    chartSlide.Title = title || slideTitle;
    let slideSubtitle = `${data.projectEndDate} (by ${data.projectPeriod})`;
    chartSlide.Subtitle = subtitle || slideSubtitle;

    let columnsById = _.keyBy(settings.columns, 'id');
    let brandScores = _.map(data.scores, d => ({
        colour: columnsById[d.columnId].colour,
        brand: d.brandName,
        finalScore: d.finalScore.toFixed(2),
        conversation: d.xConversation.toFixed(2),
        quality: d.yQuality.toFixed(2),
        community: d.zCommunity.toFixed(2)
    }));
    chartSlide.finalScoreData = { brandScores: brandScores };

    return chartSlide;
}

class FinalScoresTableRequestor {
    generatePPTXRequest (data, title, subtitle, settings) {
        return requestorHelperService.buildPresentationRequest(getSlideRequest, 'conversability_scorecard.pptx', data, title, subtitle, settings);
    }

    getSlideRequest (data, title, subtitle, settings) {
        return getSlideRequest(data, title, subtitle, settings);
    }
}

export const finalScoresTableRequestor = new FinalScoresTableRequestor();
